export default {
    entityData(state) {
        return state.entityData;
    },
    fillableSettings(state) {
        return state.fillableSettings;
    },
};
